import 'tio-data/install';
import { setBuildURLConfig } from '@warp-drive/utilities';
import Application from '@ember/application';
import config from './config/environment';
import loadInitializers from 'ember-load-initializers';
import Resolver from 'ember-resolver';
import setupInspector from '@embroider/legacy-inspector-support/ember-source-4.12';

import { getCompatModules } from 'tio-common/compat-modules';
import { getCompatModules as getReportingCompatModules } from 'tio-reporting/compat-modules';

// Register addon services and initializers under the app namespace for runtime lookup.
import * as emberSimpleAuthInitializer from 'ember-simple-auth/initializers/ember-simple-auth';
import * as cookiesService from 'ember-cookies/services/cookies';
import * as fileQueueService from 'ember-file-upload/services/file-queue';
import * as intlService from 'ember-intl/services/intl';
import * as pageTitleService from 'ember-page-title/services/page-title';
import * as scrollModifiersObserverService from 'ember-scroll-modifiers/services/scroll-modifiers-observer';
import * as notificationsService from 'tio-ui/services/notifications';

// Loose addon templates, including ember-flatpickr, resolve these modifiers by name.
import * as didInsertModifier from '@ember/render-modifiers/modifiers/did-insert';
import * as didUpdateModifier from '@ember/render-modifiers/modifiers/did-update';
import * as willDestroyModifier from '@ember/render-modifiers/modifiers/will-destroy';

const modulePrefix = config.modulePrefix;

// Strict templates import components, helpers and modifiers directly; only other modules need the resolver.
const ownModuleGlob = import.meta.glob(
  [
    './**/*.{ts,gts,js,gjs}',
    '!./app.{ts,js}',
    '!./components/**',
    '!./helpers/**',
    '!./modifiers/**',
  ],
  { eager: true }
);

function collectOwnModules(prefix: string): Record<string, Record<string, unknown>> {
  const result: Record<string, Record<string, unknown>> = {};
  for (const [path, module] of Object.entries(ownModuleGlob)) {
    const normalizedPath = path.replace(/^\.\//, `${prefix}/`).replace(/\.(ts|gts|js|gjs)$/, '');
    result[normalizedPath] = module;
  }
  return result;
}

const additionalCompatModules = getCompatModules(modulePrefix);
const reportingCompatModules = getReportingCompatModules(modulePrefix);

const compatModules = {
  ...additionalCompatModules,
  ...reportingCompatModules,
  [`${modulePrefix}/initializers/ember-simple-auth`]: emberSimpleAuthInitializer,
  [`${modulePrefix}/services/cookies`]: cookiesService,
  [`${modulePrefix}/services/file-queue`]: fileQueueService,
  [`${modulePrefix}/services/intl`]: intlService,
  [`${modulePrefix}/services/page-title`]: pageTitleService,
  [`${modulePrefix}/services/scroll-modifiers-observer`]: scrollModifiersObserverService,
  [`${modulePrefix}/services/notifications`]: notificationsService,
  [`${modulePrefix}/modifiers/did-insert`]: didInsertModifier,
  [`${modulePrefix}/modifiers/did-update`]: didUpdateModifier,
  [`${modulePrefix}/modifiers/will-destroy`]: willDestroyModifier,
  ...collectOwnModules(modulePrefix),
};

setBuildURLConfig({
  host: config.apiHost,
  namespace: '',
});

export default class App extends Application {
  modulePrefix = config.modulePrefix;
  podModulePrefix = config.podModulePrefix;
  Resolver = Resolver.withModules(compatModules);
  inspector = setupInspector(this);
}

loadInitializers(App, config.modulePrefix, compatModules);
